import { useRef } from "react";
import useImagesLoaded from "../../hooks/useImagesLoaded";
import FCHero from "../../components/Hardware/FlightController/FCHero";
import FCOverview from "../../components/Hardware/FlightController/FCOverview";
import FCSpecs from "../../components/Hardware/FlightController/FCSpecs";
import FCCompatibility from "../../components/Hardware/FlightController/FCCompatibility";
import FCUseCases from "../../components/Hardware/FlightController/FCUseCases";

export default function FCPage() {

    const containerRef = useRef(null);
    useImagesLoaded(containerRef);

    return (
        <main>
            <FCHero />
            <FCOverview />
            <FCSpecs />
            <FCCompatibility />
            <FCUseCases />
        </main>
    );
}